import React, { Component } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  DefaultButton,
  BasicInput,
  Paragraph,
  Title,
  LoadSpinner
} from '../../components';
import { requestSignIn } from '../../actions/auth';
import '../../assets/stylesheets/styles.scss';

const inicioImg = require('../../assets/images/logo-crecer-plee.png');

class Login extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      password: ''
    };
  }

  handleSingIn = () => {
    const { email, password } = this.state;
    if (email === '') {
      alert('Ingrese email');
    }
    if (password === '') {
      alert('Ingrese contraseña');
    } else {
      this.signInAsync(email, password);
    }
  };

  signInAsync = async (email, password) => {
    const { dispatch } = this.props;
    dispatch(requestSignIn({ user: { email, password } }));
  };

  componentWillMount = () => {
    const { signedIn, history } = this.props;
    if (signedIn) {
      history.push('/dashboard');
    }
  };

  onFormSubmit = e => {
    e.preventDefault();
    this.handleSingIn();
  };

  render() {
    const { email, password } = this.state;
    const { history, ongoingRequest } = this.props;
    return (
      <div>
        {ongoingRequest.signIn && <LoadSpinner />}
        <Container fluid className="h-100">
          <Row className="h-100">
            <Col
              xs={12}
              md={6}
              className="bannerLogin flexFullHeight d-none d-md-flex"
            >
              <Image src={inicioImg} alt="Fundacion Crecer" style={{ width: '400px' }} />
            </Col>
            <Col xs={12} md={6} className="flexFullHeight p-0">
              <div className="d-flex flex-column h-100 justify-content-center align-items-center w-100 px-md-3 py-md-4">
                <div className="mb-auto bannerLogin w-100 d-flex justify-content-center align-items-center p-2 p-md-0">
                  <Image src={inicioImg} alt="Fundacion Crecer" className="d-md-none" style={{ width: '360px', height: 'auto' }}/>
                </div>
                <div className="w-100" style={{ maxWidth: '300px' }}>
                  <form onSubmit={this.onFormSubmit}>
                    <Title
                      title="INICIAR SESIÓN"
                      style={{ textAlign: 'center' }}
                      className="text-primary"
                    />
                    <Paragraph
                      text="Programa PRIMERO LEE - Fundación Crecer"
                      style={{ textAlign: 'center' }}
                    />
                    <BasicInput
                      placeholder="Correo"
                      size="md"
                      styleClass="borderInput"
                      value={email}
                      onChange={e => this.setState({ email: e.target.value })}
                    />
                    <BasicInput
                      placeholder="Contraseña"
                      size="md"
                      styleClass="borderInput"
                      type="password"
                      value={password}
                      onChange={e =>
                        this.setState({ password: e.target.value })
                      }
                    />
                    <DefaultButton
                      text="Olvidé mi contraseña"
                      variant="link"
                      style={{ textAlign: 'right' }}
                      onClick={() => history.push('/password/forgot')}
                      block
                    />
                    <div className="text-center">
                      <DefaultButton
                        text="Ingresar"
                        size="md"
                        type="submit"
                        style={{ width: '140px', marginTop: '30px' }}
                      />
                    </div>
                  </form>
                </div>
                <div className="mt-auto pt-4 d-flex flex-column flex-md-row" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { ongoingRequest, signedIn } = state.auth;
  return {
    ongoingRequest,
    signedIn
  };
};

export default withRouter(connect(mapStateToProps)(Login));
